import { FaFilter, FaSort } from 'react-icons/fa6'
import { BodyTooltip } from '../BodyTooltip'
import { useEffect, useState } from 'react'

const ColumnHeader = (props: any) => {
    const {
        displayName,
        column,
        progressSort, // AG Grid built-in sort handler
        showColumnMenu,
        api,
    } = props

    const sort = column.getSort() // 'asc' | 'desc' | null

    const [filterCount, setFilterCount] = useState<number>(0)
    const data: any = column?.colDef?.filterParams?.selectedFilters
    const key: any = column?.colDef?.filterParams?.filterKey || column?.colDef?.filterParams?.columnKey

    useEffect(() => {
        if (!data || !key) {
            setFilterCount(0)
            return
        }

        const value = data[key]

        // Invalid or empty values
        if (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0)) {
            setFilterCount(0)
            return
        }

        // Valid values
        if (Array.isArray(value)) {
            setFilterCount(value.length)
        } else if (typeof value === 'string') {
            setFilterCount(value.split(',').length)
        } else {
            setFilterCount(1)
        }
    }, [data, key])

    const onSort = () => {
        if (column.colDef.sortable) {
            progressSort()
        }
    }

    return (
        <div className="flex items-center justify-between w-full select-none">
            {/* LEFT: Column title + sort click */}
            <div className="flex-1 min-w-0">
                <button type="button" className="flex items-center gap-1 w-full" onClick={onSort}>
                    <BodyTooltip text={displayName} className="flex-1 min-w-0">
                        <span className="block font-medium whitespace-nowrap truncate text-left">{displayName}</span>
                    </BodyTooltip>

                    {column.colDef.sortable && (
                        <div className="w-[0.8rem] text-[0.6rem]">
                            {sort === 'asc' && '▲'}
                            {sort === 'desc' && '▼'}
                            {sort == null && <FaSort />}
                        </div>
                    )}
                </button>
            </div>

            {column.colDef.filter && (
                <button
                    type="button"
                    className={`cursor-pointer flex-shrink-0 w-[1rem] text-slate-400 hover:text-slate-600 relative ${filterCount > 0 ? 'text-slate-800' : ''}`}
                    onClick={(e) => {
                        api.hideColumnFilter()
                        showColumnMenu(e.currentTarget)
                    }} // ← FIX!!!
                    onMouseDown={(e) => e.stopPropagation()} // prevent sort
                >
                    <FaFilter />
                    {filterCount > 0 && (
                        <div className="absolute rounded-full top-[-0.5rem] right-[-0.1rem] bg-primary w-[0.8rem] h-[0.8rem] text-[0.5rem] font-bold flex items-center justify-center leading-none pb-[2px]">{filterCount > 9 ? '+9' : filterCount}</div>
                    )}
                </button>
            )}
        </div>
    )
}

export default ColumnHeader
